export type ConfiguredBillingProviderAccountScope = string;

/**
 * Deterministic connection identity for application-configured providers.
 * Same app + provider + environment + scope always yields the same
 * `account_reference`. Never derive this from credential material.
 */
export function deriveConfiguredProviderAccountReference(input: {
	applicationId: string;
	environment: "test" | "live";
	provider: string;
	scope?: ConfiguredBillingProviderAccountScope;
}): string {
	const applicationId = input.applicationId.trim();
	const provider = input.provider.trim();
	const scope = input.scope?.trim();
	if (
		scope == null ||
		scope.length === 0 ||
		scope === "organization"
	) {
		return `${applicationId}-${provider}-${input.environment}`;
	}
	return `${applicationId}-${provider}-${scope}-${input.environment}`;
}
